<template>
	<div class="mybg-wrap">
		<cIndex></cIndex>
		<div class="mybaogao">
			<div class="null-list" v-show="isNull">
				<img src="../assets/04.png" alt="">
				<p>暂无检测报告数据</p>
				<div>
					<span>造成没有检测报告的原因可能是：</span>
					<ul>
						<li>1.未填写正确的身份证号,无法关联查询出检测报告 ; <router-link to="/setinfo" tag="i">立即完善</router-link></li>
						<li>2.还没有进行过脑能力检测 ; <router-link :to="{path:'/payment',query:{pID:1}}" tag="i">立即检测</router-link></li>
					</ul>
				</div>
			</div>
			<div class="baogao-list" v-show="isList">
				<table> 
					<tr>
						<th class="box"></th>
						<th class="box"></th>
						<th>序号</th>
						<th class="box"></th>
						<th>检测人</th>
						<th class="box"></th>
						<th>检测结果</th>
						<th class="box"></th>
						<th>检测时间</th>
						<th class="box"></th>
						<th>检测套餐</th>
						<th class="box"></th>
						<th class="update-right">操作</th>
					</tr>
					<tr v-for="(item,index) in getReportList">
							<td class="box"></td>
							<td class="box"></td>
							<td><b>{{index+1}}</b></td>
							<td class="box"></td>
							<td><b>{{item.username}}</b></td>
							<td class="box"></td>
							<td>{{item.rezhi}}</td>
							<td class="box"></td>
							<td>{{item.cpTime}}</td>
							<td class="box"></td>
							<td>{{item.tc}}</td>
							<td class="box"></td>
							<td class="lookReport" @click="lookREport(item.id,item.packageid,item.bid)">查看</td>
					</tr>
				</table>
				<div class="block">
					<span class="el-pagination__total">共 <span>{{getPages}}</span> 页</span>
					<el-pagination @current-change="handleCurrentChange" :page-size="pageSize" :total="getTotal" layout="prev, pager, next, jumper">
					</el-pagination>
					<el-button size="mini">确定</el-button>
				</div>
			</div>
		</div>
	</div>	
</template>
<script>
    import cIndex from '@/components/header'
    import indexs from "./index.vue";
	const components = {
		cIndex
	}
	export default {
		components: components,
		data(){
			return {
				isList: false,
				isNull: false,
				getPages: null,
				getTotal: null,
				pageSize: null,
				getReportList:null,
			}
		},//data
		created(){
			this.$http.post('http://192.168.11.86/api/v1/page/hospitalmanage', {
				a:1
				}).then(function(res) {
				
			});

			this.$http.post(urls.urltest + '/personal/getMyReport.json', {
					token: localStorage.getItem('token'),
				}).then(function(res) {
				if(res.body.code == 500){
					 location.href = "/#/"
				}else{
					if(res.body.records.length){
						this.isList = true
						this.isNull =  false
						this.getPages = res.body.pages;
						this.getTotal = res.body.total;
						this.pageSize = res.body.size;
						this.getReportList = res.body.records
					}else{
						this.isList = false
			            this.isNull =  true
					}
				}
			});
		},
		methods: {
			handleCurrentChange(val) {
					this.$http.post(urls.urltest + '/personal/getMyReport.json', {
						token: localStorage.getItem('token'),
						current: val,
					}).then(function(res) {
						this.getReportList = res.body.records
					});
					console.log(val)
					this.pageChange = val
					console.log(this.pageChange)
				},
			lookREport(reportID,childReportID,reportBid) {
				localStorage.setItem('eid',reportID)
				if(childReportID == 6 && reportBid == 2){
						window.open('/#/mechanismCard')
				}else if(childReportID == 1 && reportBid == 1){
						window.open('/#/mechanismPrin')
				}else{
						window.open('/#/reportpage')
				}
			}
		}
	}
</script>	
<style lang="scss">
	@import "../styles/core/reset.scss";
	.mybg-wrap{
		width: 100%;
		height: 100%;
		@include flexbox;
		@include flex-direction(column);
		.mybaogao{
			@include flex;
			width: 100%;
			height: 100%;
			overflow-y: auto;
			position: relative;
			.null-content{
				width: 8rem;
				height: 5rem;
				background: #fff;
				box-shadow: 0 0 3px #C3C3C3;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%,-50%);
				@include flexbox;
				@include flex-direction(column);
				h3{
					height: .6rem;
					line-height: .6rem;
					text-align: center;
					font-size: 16px;
					color: #555555;
					border-bottom: 1px solid #eee;
				}
				div{
					@include flex;
					width: 100%;
					position: relative;
					img{
						position: absolute;
						left: 50%;
						top: .6rem;
						transform: translate(-50%,0);
					}
					p{
						position: absolute;
						top: 1.8rem;
						left: 50%;
						transform: translate(-50%,0);
						font-size: 16px;
						color: #555555;
					}
					button{
						width: 1.2rem;
						height: .35rem;
						background: #467DE5;
						border: none;
						color: #fff;
						box-shadow: 0 2px 4px #c3c3c3;
						position: absolute;
						bottom: .6rem;
						left: 50%;
						transform: translate(-50%,0);
					}
				}
			}
			.baogao-list{
				width: 12rem;
				background: #fff;
				margin: .2rem auto;
				box-shadow: 0 0 2px #C3C3C3;
				table{
					box-sizing: border-box;
					width: 100%;
					th{
						border-bottom: 1px solid #EAEAEA;
						box-sizing: border-box;
						background:  #F4F6F9;
						font-size: 14px;
					}
					tr{
						height: .6rem;
						color: #555;
						&:not(:last-child){
							border: 1px solid #F6F6F6;
						};
					}
					.lookReport{
						cursor: pointer;
					}
					.box{
						width: .3rem;
					}
				}
				.block{
					padding: 100px 0 91px 0;
					text-align: center;
					justify-content: center;
					display: flex;
					.el-pagination__total {
						line-height: 32px;
						color: #48576a;
					}
					.el-icon-arrow-left {
			          display: inline-block!important;
		             }
			
					 .el-icon-arrow-right {
						display: inline-block!important
					}
					
					.el-pagination .btn-prev:after {
						content: '上一页';
					}
					
					.el-pagination .btn-next:before {
						content: '下一页';
					}
				}
			}
			.null-list{
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%,-50%);
				p{
					text-align: center;
					font-size: 16px;
					color: #666666;
					padding-top: .6rem;
					font-weight: bold;
				}
				div{
					@include flexbox;
					font-size: 14px;
					color: #666666;
					line-height: .3rem;
					padding-top: .3rem;
					i{
						border-bottom: 1px solid #467DE5;
						color: #467DE5;
						cursor: pointer;
					}
				}
			}
		}	
	}
</style>


// WEBPACK FOOTER //
// mybaogao.vue?6b29cf7e